import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './user/login/login.component';
import {HomeComponent} from './home/home.component';
import {FieldComponent} from './field/field.component';
import {LineComponent} from './field/line/line.component';
import {TreeComponent} from './field/line/tree/tree.component';
import {AddFieldComponent} from './field/add-field/add-field.component';
import {EditFieldComponent} from './field/edit-field/edit-field.component';
import {AddTreeComponent} from './field/line/tree/add-tree/add-tree.component';
import {AddTruffleComponent} from './field/line/tree/truffle/add-truffle/add-truffle.component';
import {TruffleComponent} from './field/line/tree/truffle/truffle.component';
import {EditTreeComponent} from './field/line/tree/edit-tree/edit-tree.component';
import {EditTruffleComponent} from './field/line/tree/truffle/edit-truffle/edit-truffle.component';
import {LoginActivate} from './user/login-activate.guard';
import {UserComponent} from './user/user.component';
import {EditUserComponent} from './user/edit-user/edit-user.component';
import {ForgotPasswordComponent} from './user/forgot-password/forgot-password.component';
import {SignUpComponent} from './user/sign-up/sign-up.component';
import {BonusComponent} from './bonus/bonus.component';
import {AddBonusComponent} from './bonus/add-bonus/add-bonus.component';
import {EditBonusComponent} from './bonus/edit-bonus/edit-bonus.component';
import {TakeTruffleComponent} from './home/take-truffle/take-truffle.component';
import {TruffleFoundComponent} from './home/truffle/truffle-found.component';
import {FieldViewComponent} from './home/field-view/field-view.component';
import {LandingComponent} from './landing/landing.component';


const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: 'login'},
  {path: 'landing', component: LandingComponent},
  {path: 'dashboard', component: FieldComponent, canActivate: [LoginActivate]},
  {path: 'home', component: HomeComponent, canActivate: [LoginActivate]},
  {path: 'truffleFound', component: TruffleFoundComponent, canActivate: [LoginActivate]},
  {path: 'home/userId/:userId', component: HomeComponent, canActivate: [LoginActivate]},
  {path: 'fieldView/:fieldId', component: FieldViewComponent, canActivate: [LoginActivate]},
  {path: 'fieldView', component: FieldViewComponent, canActivate: [LoginActivate]},
  {path: 'login', component: LoginComponent},
  {path: 'forgotPassword', component: ForgotPasswordComponent},
  {path: 'signUp', component: SignUpComponent},
  {path: 'user', component: UserComponent, canActivate: [LoginActivate]},
  {path: 'editUser', component: EditUserComponent, canActivate: [LoginActivate]},
  {path: 'field', component: FieldComponent, canActivate: [LoginActivate]},
  {path: 'bonus', component: BonusComponent, canActivate: [LoginActivate]},
  {path: 'addBonus', component: AddBonusComponent, canActivate: [LoginActivate]},
  {path: 'editBonus', component: EditBonusComponent, canActivate: [LoginActivate]},
  {path: 'editField', component: EditFieldComponent, canActivate: [LoginActivate]},
  {path: 'addField', component: AddFieldComponent, canActivate: [LoginActivate]},
  {path: 'field/:fieldId', component: LineComponent, canActivate: [LoginActivate]},
  {path: 'field/:fieldId/line/:lineId', component: TreeComponent, canActivate: [LoginActivate]},
  {path: 'field/:fieldId/line/:lineId/tree/:treeId', component: TreeComponent, canActivate: [LoginActivate]},
  {path: 'addTree', component: AddTreeComponent, canActivate: [LoginActivate]},
  {path: 'editTree', component: EditTreeComponent, canActivate: [LoginActivate]},
  {path: 'addTruffle', component: AddTruffleComponent, canActivate: [LoginActivate]},
  {path: 'takeTruffle', component: TakeTruffleComponent, canActivate: [LoginActivate]},
  {path: 'editTruffle', component: EditTruffleComponent, canActivate: [LoginActivate]},
  {path: 'field/:fieldId/line/:lineId/tree/:treeId/truffle', component: TruffleComponent, canActivate: [LoginActivate]},
  {path: '**', component: FieldComponent, canActivate: [LoginActivate]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
